import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import {
  ListRouteWavesQueryType,
  RouteWaveConstantsType,
  RouteWaveListItemType,
  RouteWavePaginationType,
} from 'features/Midmile/service/routeAndSchedule'
import { GetAllLocationsResponseType } from 'features/Location/services/location'
import {
  SLICE_NAME,
  fetchRouteAndSchedule,
  fetchRouteConfig,
  fetchLocations,
  downloadRouteMaster,
} from './routeAndScheduleThunk'

export type ExportActiveStatusType = 'active' | 'inactive'

export interface ExportModalStateType {
  isOpen: boolean
  selectedLocationID: number | null
  activeStatus: ExportActiveStatusType
  isLoading: boolean
}

export interface RouteAndScheduleStateInterface {
  query: ListRouteWavesQueryType
  isLoading: boolean
  data: RouteWaveListItemType[]
  pagination?: RouteWavePaginationType
  constants: RouteWaveConstantsType
  locations: GetAllLocationsResponseType
  exportModal: ExportModalStateType
}

const initialExportModal: ExportModalStateType = {
  isOpen: false,
  selectedLocationID: null,
  activeStatus: 'active',
  isLoading: false,
}

const initialConstants: RouteWaveConstantsType = {
  distance_types: [],
  trip_types: [],
  rit: [],
  wave: [],
}

const initialState: RouteAndScheduleStateInterface = {
  query: {},
  isLoading: false,
  data: [],
  pagination: undefined,
  constants: initialConstants,
  locations: [],
  exportModal: initialExportModal,
}

const slice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    resetState: () => initialState,
    setQuery: (state, { payload }: PayloadAction<RouteAndScheduleStateInterface['query']>) => {
      state.query = { ...payload }
    },
    setExportModalOpen: (state, { payload }: PayloadAction<boolean>) => {
      state.exportModal.isOpen = payload
    },
    setExportModalLocationID: (state, { payload }: PayloadAction<number | null>) => {
      state.exportModal.selectedLocationID = payload
    },
    setExportModalActiveStatus: (state, { payload }: PayloadAction<ExportActiveStatusType>) => {
      state.exportModal.activeStatus = payload
    },
    resetExportModal: (state) => {
      state.exportModal = initialExportModal
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRouteAndSchedule.pending, (state) => {
        state.isLoading = true
      })
      .addCase(fetchRouteAndSchedule.fulfilled, (state, { payload }) => {
        state.isLoading = false
        state.data = payload.items
        state.pagination = payload.pagination
      })
      .addCase(fetchRouteAndSchedule.rejected, (state) => {
        state.isLoading = false
      })
      .addCase(fetchRouteConfig.fulfilled, (state, { payload }) => {
        state.constants = payload
      })
      .addCase(fetchLocations.fulfilled, (state, { payload }) => {
        state.locations = payload
      })
      .addCase(downloadRouteMaster.pending, (state) => {
        state.exportModal.isLoading = true
      })
      .addCase(downloadRouteMaster.fulfilled, (state) => {
        state.exportModal.isLoading = false
      })
      .addCase(downloadRouteMaster.rejected, (state) => {
        state.exportModal.isLoading = false
      })
  },
})

export const {
  resetState,
  setQuery,
  setExportModalOpen,
  setExportModalLocationID,
  setExportModalActiveStatus,
  resetExportModal,
} = slice.actions
export default slice.reducer
